import React from "react";
import {Box, Button} from "@mui/material";
import {isSameDate} from "../../utils/Utils";
import {HILIGHT_COLOR} from "../../constants/constants";

const weekdays = ["일", "월", "화", "수", "목", "금", "토"];

interface WeekdaySelectorProps {
    selectedDates: Date[];
    setSelectedDates: (dates: Date[]) => void;
    calendarDates: Date[]; // 달력에 표시된 전체 날짜 리스트
    disabledDates: Date[]; // 선택 불가능한 날짜 리스트
    isSelectingAttend?: boolean;
}

const WeekdaySelector: React.FC<WeekdaySelectorProps> = ({
                                                             selectedDates,
                                                             setSelectedDates,
                                                             calendarDates,
                                                             disabledDates,
                                                         }) => {
    const toggleWeekday = (weekdayIndex: number) => {
        const datesWithTargetWeekday = calendarDates.filter((date) => date.getDay() === weekdayIndex);
        const targetDates = datesWithTargetWeekday.filter((date) => !disabledDates.some((disabled) => isSameDate(disabled, date)));
        const isCurrentlyAllSelected = targetDates.length > 0 && targetDates.every((date) => selectedDates.some((selected) => isSameDate(selected, date)));

        let newSelectedDates;
        if (isCurrentlyAllSelected) {
            newSelectedDates = selectedDates.filter(
                (date) => !targetDates.some((toggleDate) => isSameDate(date, toggleDate))
            );
        } else {
            const addDates = targetDates.filter((date) => !selectedDates.some((selected) => isSameDate(selected, date)));
            newSelectedDates = [...selectedDates, ...addDates];
        }

        setSelectedDates(newSelectedDates);
    };

    return (
        <Box display="flex" justifyContent="space-between">
            {weekdays.map((day, index) => {
                return (
                    <Button
                        key={index}
                        variant="contained"
                        sx={{
                            minWidth: 40,
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            backgroundColor: HILIGHT_COLOR,
                            color: "white",
                            boxShadow: "none",
                            "&:hover": {
                                backgroundColor: HILIGHT_COLOR,
                                boxShadow: "none"
                            },
                        }}
                        onClick={() => toggleWeekday(index)}
                    >
                        {day}
                    </Button>
                );
            })}
        </Box>
    );
};

export default WeekdaySelector;